// extracted by mini-css-extract-plugin
export default {"text":"ExpiredVerificationModal_text__6WjPK","button":"ExpiredVerificationModal_button__yFI8N"};